import React from 'react';
import { Tooltip } from 'react-tooltip';
import { Icon } from '@lsg/components';
import './SocialMediaDropdown.css';

export const SocialMediaDropdown = (props) => {
    return (
        <>
            <span
                data-tooltip-id={props.data.name}
                data-tooltip-delay-hide={0}
            >
                <span className="border border-primary2 flex overflow-hidden shadow-xl h-5 mt-0.5">
                    {props.data.img}
                </span>
            </span>
            <Tooltip
                id={props.data.name}
                place="top"
                effect="solid"
                className="dropdown-tooltip rounded-lg"
                clickable={true}
            >
                <h1>{props.data.name}</h1>
                <ul className="links">
                    {props.data.links.map((link) => (
                        <li
                            key={link.url}
                            className={'link-list'}
                        >
                            <a
                                href={link.url}
                                target="_blank"
                                rel={'noopener noreferrer'}
                            >
                                <Icon
                                    icon={link.icon}
                                    variant={'solid'}
                                ></Icon>
                            </a>
                        </li>
                    ))}
                </ul>
            </Tooltip>
        </>
    );
};
